<div class="grid grid-nogutter flex justify-content-start align-items-center width-100 pl-3" style="gap: 10px">
  <div class="col-fixed">
    <app-thumbnail
      (click)="navigateTo(item)"
      [imgSrc]="item.follower.avatar | mediaObject"
      [circle]="true"
      size="lg"
    >
    </app-thumbnail>
  </div>
  <div class="col-6" style="min-width: 200px">
    <div>
      <a (click)="navigateTo(item)">{{ item.follower.username }}</a>
      <br>
      <span *ngIf="item | projectUserCount: currentUser as projectUserCount">
        <ng-container *ngIf="projectUserCount.hasUser || projectUserCount.projectCount">
          {{ 'common.follows.user_projects' | translate: {
            user: projectUserCount.hasUser ? (projectUserCount.userTranslateParam | lowercase) : '',
            project: projectUserCount.projectTranslateParam | translateSelector: projectUserCount.projectCount,
            and: projectUserCount.hasUser && projectUserCount.projectCount ? ('common.and' | translate) : ''
          } }}
        </ng-container>
      </span>
    </div>
    <div class="width-100">
      <swiper [config]="swiperConfig">
        <ng-template swiperSlide *ngFor="let followed of item.followed | filterCollectionByType: 'Project'">
          <div>
            <app-thumbnail
              [imgSrc]="followed.avatar | mediaObject"
              [circle]="true"
              size="md"
            >
            </app-thumbnail>
          </div>
        </ng-template>
      </swiper>
    </div>
  </div>
  <div class="col-fixed flex ml-auto gap-2 relative w-3rem h-3rem" *ngIf="item.follower?.slug && !item.follower?.deleted">
    <app-item-action-dial
      [isFollowedByCurrentUser]="isFollowedByCurrentUser()"
      [isReactedByCurrentUser]="isLikedByCurrentUser()"
      [subjectUserVM]="item.follower"
      [currentUserVM]="currentUser"
    ></app-item-action-dial>
  </div>
</div>
